var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"align-center":"","justify-center":""}},[_c('v-flex',{attrs:{"xs10":""}},[_c('v-card',{staticClass:"px-5 py-5"},[_vm._v("\n        Veuillez choisir un project sur la gauche, ou en créer un nouveau\n    ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }